import { BrowserRouter as HashRouter, Routes, Route } from 'react-router-dom';
import Home from "./pages/Home";
import Linguagens from './pages/Linguagens';
import { MainCategories } from './pages/MainCategories';
import { ListingItems } from './pages/ListingItems';
import { LanguageProvider } from './context/LanguageContext';
import Subcategories from './pages/SubCategories';

function App() {
  return (
    <LanguageProvider>
      <HashRouter>
        <Routes>
          <Route path="" element={<Home />} />
          <Route path="menu-linguagens" element={<Linguagens />} />
          <Route path="menu-categorias" element={<MainCategories />} />
          <Route path="menu-categorias/:categoryId" element={<Subcategories />} />
          <Route path="menu-categorias/:categoryId/:subcategoryId" element={<ListingItems />} />
        </Routes>
      </HashRouter>
    </LanguageProvider>
  );
}

export default App;
